import { Injectable } from '@angular/core';
import { AuthService } from '../services.module/auth.service';
import { VertragApiService } from '../../generated/api/vertrag/vertrag.service';
import { Observable, of } from 'rxjs';
import type { VertragData, VertragHandle } from '../../generated/api/kreditportalBackendAPI.schemas';
import { map, switchMap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class VertraegeService {

    constructor(
        private readonly authService: AuthService,
        private readonly vertragApiService: VertragApiService
    ) {
    }

    getVertraegeNummernListe(): Observable<VertragHandle[]> {
        const activeKunde = this.authService.getActiveKunde();

        if (!activeKunde || !activeKunde.$_clientOfMaklerOrStbr && !activeKunde.$_directKunde && !activeKunde.$_clientOfFirmenverbund) {
            return of([]);
        }

        return this.vertragApiService.getVertraegeZuKunde(activeKunde.vsnr);
    }

    getVertrage(): Observable<VertragData[]> {
        return this.getVertraegeNummernListe().pipe(
            switchMap(vertragHandleList => {
                const vsnrs = vertragHandleList.map(vertragHandle => vertragHandle.vsnrNumerisch);

                return this.vertragApiService.getVertraegeData({ vsnrs });
            })
        );
    }

    getVertrag(vsnr: string): Observable<VertragData> {
        return this.getVertrage().pipe(
            map(vertraege => vertraege.find(vertrag => vertrag.vertragHandle.vsnrNumerisch === vsnr))
        );
    }

}
